import React from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import { Fragment } from 'react';

/**
 * physical Activity component
 */
const PhysicalActivitySlider = (props) => (
  <div className="nppe2-fc-weeks-litter-slider nppe2-fc-slider">
    <h2>{props.data.label}</h2>
    <hr/>

    <div className="row">
      <div className="col-xs-11">


        { props.animalType === 'dog' &&
          <Fragment>
            <div className="row">
              <div className="col-xs-6 nppe2-fc-slider__text" disabled={props.selectedCriticalCare}>
                {props.data.labelDuration}
              </div>
              <div className="col-xs-6 text-right nppe2-fc-slider__text--red" disabled={props.selectedCriticalCare}>
                {props.data.data[props.animalType][Object.keys(props.data.data[props.animalType])[props.selectedDuration]].label}
              </div>
            </div>
            <Slider
              name="nppe2-fc-duration-slider"
              value={props.selectedDuration}
              min={0}
              max={Object.keys(props.data.data[props.animalType]).length - 1}
              step={1}
              onChange={(value) => props.onSelectDuration(value)}
              disabled ={props.selectedCriticalCare}
            />
          </Fragment>
        }

      </div>

    </div>
  </div>
);

export default PhysicalActivitySlider;
